import { render, staticRenderFns } from "./HSSOrderList.vue?vue&type=template&id=b92ff94c&scoped=true&"
import script from "./HSSOrderList.vue?vue&type=script&lang=js&"
export * from "./HSSOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b92ff94c",
  null
  
)

export default component.exports